import { Component, OnInit, ElementRef } from '@angular/core';

import { ContainerViewModel } from '../../types/control.types';
import { AbstractControlContainerComponent } from '../abstract-control-container/abstract-control-container.component';
import { ControlTypeName } from '../../types/control-type-name';

import { ControlTranslateService } from '../../services';

@Component({
  // tslint:disable-next-line: component-selector
  selector: '[dy-row]',
  templateUrl: './row.component.html',
  styleUrls: ['./row.component.css']
})
export class RowComponent extends AbstractControlContainerComponent<ContainerViewModel> implements OnInit {
  type: string = ControlTypeName.row;
  isDesign: boolean = false;
  model: ContainerViewModel;

  get designHostClass(): string {
    return '';
  }

  constructor() {
    super();
  }

  ngOnInit() {}
}
